module.exports = __webpack_public_path__ + "static/media/dashboard-thumbnail.52580982.PNG";